import { c as _c } from "react/compiler-runtime";
import { useDeepLink } from '@/hooks/useDeepLink';
import { useMemo } from 'react';
export function useConversationDeeplink() {
  const $ = _c(4);
  const {
    deepLinkConversationId,
    setDeepLinkConversationId
  } = useDeepLink();
  const t0 = !!deepLinkConversationId;
  let t1;
  if ($[0] !== deepLinkConversationId || $[1] !== setDeepLinkConversationId || $[2] !== t0) {
    t1 = {
      deepLinkConversationId,
      isConversationDeeplink: t0,
      setDeepLinkConversationId
    };
    $[0] = deepLinkConversationId;
    $[1] = setDeepLinkConversationId;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}